import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../base-template-editor/template-editor.component';

@Component({
    selector: 'app-rcs-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/rcs-template/"
      channelLabel="RCS"
      namePlaceholder="Enter RCS name"
      emptyMessage="No RCS found!"
      heartbeatType="rcs"
      [guardByProcessing]="false"
      [subscribeToMedia]="true"
      [defaultBlocks]="defaultBlocks" />
  `
})
export class RcsTemplateComponent {
  protected readonly templateType = TypeEnum.RCS;

  protected readonly defaultBlocks: { name: string; variables: Record<string, string> }[] = [
    {
      name: 'rcs',
      variables: { text: '', image_url: '', cta_text: '', cta_link: '' },
    },
  ];
}
